import React from "react"
import spinner from "../images/ic-spinner-36.png"

export const Loader = () => (
    <div className="loading-wrapper">
        <img src={spinner} className="spinner" alt="" />
    </div>
)
